import { schema } from "normalizr";
import { AccountTypeSchema } from "../schema/account-type";

const ChartOfAccountSchema = new schema.Entity("chartOfAccounts", {
  chartAccountType: AccountTypeSchema
});

const ChartOfAccountArraySchema = new schema.Array(ChartOfAccountSchema);

export { ChartOfAccountSchema, ChartOfAccountArraySchema };